import { ComponentProps, ReactNode } from 'react';

import BackButton from '@components/buttons/BackButton';
import TertiaryButton from '@components/buttons/TertiaryButton';
import Tag, { TagProps } from '@components/labels/Tag';
import styles from '@components/layout/PageHeader.module.css';
import Heading1 from '@components/typography/Heading1';

type Props = {
  actionButtonProps?: ComponentProps<typeof TertiaryButton>;
  backRouterLink?: string;
  children?: ReactNode;
  description?: string;
  tagProps: TagProps[];
  title: string;
};

const PageHeader = ({ actionButtonProps, backRouterLink, children, description, tagProps, title }: Props) => (
  <div>
    <div className={styles.toolbar}>
      <BackButton routerLink={backRouterLink} />
      {actionButtonProps && <TertiaryButton {...actionButtonProps} />}
    </div>
    {children}
    <div className={styles.tags}>
      {tagProps.map(tagProp => (
        <Tag key={tagProp.text} {...tagProp} spacing />
      ))}
    </div>
    <div>
      <Heading1>{title}</Heading1>
    </div>
    {description && <div className={styles.descriptionSpacing}>{description}</div>}
  </div>
);

export default PageHeader;
